import {
  Component,
  computed,
  effect,
  ElementRef,
  input,
  signal,
  viewChild,
  WritableSignal,
} from '@angular/core';
import { CardComponent } from '@sportello-balneari/shared-components';
import { ButtonModule } from 'primeng/button';
import { ActionPlanStrategies } from '../../../../../api/interfaces';

@Component({
  selector: 'lib-result-strategic-plan-card',
  standalone: true,
  imports: [ButtonModule, CardComponent],
  templateUrl: './strategic-plan-card.component.html',
})
export class ResultStrategicPlanCardComponent {
  strategies = input<ActionPlanStrategies[]>();

  scrollContainer = viewChild<ElementRef<HTMLDivElement>>('scrollContainer');

  containerIsAtStart = signal(true);
  containerIsAtEnd = signal(true);

  actions = computed(() => {
    const list = this.strategies();
    if (!list) return [];

    return list.map((strategy) => {
      const priorityValue = strategy.priority || 'Low';
      let timeframe = 'Lungo Termine';
      if (priorityValue === 'High') timeframe = 'Breve Termine';
      else if (priorityValue === 'Medium') timeframe = 'Medio Termine';

      return {
        priority: priorityValue === 'High' ? 'ALTA' : priorityValue === 'Medium' ? 'MEDIA' : 'BASSA',
        timeframe,
        description: strategy.description || '',
        actions: strategy.actions,
        type: priorityValue.toLowerCase(),
      };
    });
  });

  scroll(direction: 'left' | 'right'): void {
    const el = this.scrollContainer()?.nativeElement;
    if (el) {
      el.scrollBy({
        left: direction === 'left' ? -(el.offsetWidth * 0.75) : el.offsetWidth * 0.75,
        behavior: 'smooth',
      });
    }
  }

  constructor() {
    effect(() => {
      const container = this.scrollContainer();
      if (!container) return;
      const actions = this.actions();
      if (actions.length === 0) {
        this.containerIsAtStart.set(true);
        this.containerIsAtEnd.set(true);
        return;
      }
      this.updateContentScroll(container, this.containerIsAtStart, this.containerIsAtEnd);
    });
  }

  private updateContentScroll(
    content: ElementRef<HTMLDivElement>,
    startSignal: WritableSignal<boolean>,
    endSignal: WritableSignal<boolean>,
  ) {
    const update = () => {
      const el = content.nativeElement;
      startSignal.set(el.scrollLeft === 0);
      endSignal.set(el.scrollLeft + el.clientWidth >= el.scrollWidth - 1);
    };

    if (typeof requestAnimationFrame !== 'undefined') {
      requestAnimationFrame(update);
    } else {
      setTimeout(update, 0);
    }

    content.nativeElement.onscroll = update;
  }
}
